/* ONE ACCORDION BEHAVIOUR — the close direction.
   The shared `.ns-details` rule (ns-ui-enhancements.css) eases open in
   every engine and eases closed where content-visibility transitions
   (Chromium, Firefox). WebKit applies the closed state at once, so a
   summary click on an open panel is staged here: the panel keeps [open]
   while [data-ns-closing] runs the grid row to 0fr, then open is removed.
   Native semantics stay intact — closed content is still hidden-matchable
   for find-in-page, and reduced motion or a programmatic close snaps. */
(function () {
  if (!('HTMLDetailsElement' in window) || !document.addEventListener) return;
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  /* Fallback timer if transitionend never arrives: the shared duration
     token plus a frame or two. */
  function guardMs() {
    var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ns-disclose-dur'));
    return (v > 0 ? v * 1000 : 320) + 60;
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest ? event.target.closest('summary') : null;
    if (!summary) return;
    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS' || !details.classList.contains('ns-details')) return;
    if (!details.open) return;

    if (details.hasAttribute('data-ns-closing')) { event.preventDefault(); return; }
    if (reduce.matches) return;

    event.preventDefault();
    details.setAttribute('data-ns-closing', '');

    var done = false;
    function finish() {
      if (done) return;
      done = true;
      details.removeEventListener('transitionend', onEnd);
      details.removeAttribute('data-ns-closing');
      details.open = false;
    }
    function onEnd(ev) {
      if (ev.target !== details || ev.propertyName !== 'grid-template-rows') return;
      finish();
    }
    details.addEventListener('transitionend', onEnd);
    setTimeout(finish, guardMs());
  });
})();
